var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.TomcatDeploy", function(busy, octopusRepository) {
      return {
          executionLocation: actionExecutionLocations.alwaysOnTarget,
          canChooseRoles: true,
          canHaveChildren: function() { return true; },
          canBeChild: true,
          hasPackages: function(action) { return true; },
          summaryTemplateUrl: "areas/projects/actions/tomcat/Octopus.TomcatDeploy_summary.html",
          editTemplateUrl: "areas/projects/actions/tomcat/Octopus.TomcatDeploy_edit.html",
          features: {
              permanent: ["Octopus.Features.TomcatDeployManager"],
              optional: ["Octopus.Features.CustomScripts",
                  "Octopus.Features.JsonConfigurationVariables",
                  "Octopus.Features.SubstituteInFiles",
                  "Octopus.Features.JsonConfigurationVariables"],
              initial: []
          },
          summaryLink: function ($scope, element) {
              if ($scope.properties["Octopus.Action.Package.PackageId"]) {
                  var variableExpressionRegex = /^#{(.*?)}$/;
                  var matches = $scope.properties["Octopus.Action.Package.PackageId"].match(variableExpressionRegex);
                  $scope.packageId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.PackageId"];

                  matches = $scope.properties["Octopus.Action.Package.FeedId"].match(variableExpressionRegex);
                  $scope.feedId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.FeedId"];
                  return octopusRepository.Feeds.get($scope.feedId).then(function (feed) {
                      $scope.feedName = feed.Name;
                  });
              }
          }
      };
    });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/tomcat/Octopus.TomcatDeploy.js
// module id = 6506960772362336
// module chunks = 1